@let email = selectors.email | select:'';
<mat-card class="max-w-[25rem] md:shrink-0">
  <mat-card-content class="flex flex-col gap-y-3">
    <div class="text-headline-large">Verify Email</div>
    <div class="text-body-large">
      <p>An email was sent to:</p>
      <p>{{ email }}</p>
      <p>Please enter the six-digit verification code below:</p>
    </div>
    <mx-input-form-field fieldName="verificationCode" [externalLabel]="true" [uppercaseExternalLabel]="false" overrideLabel="Verification Code"
                         [formGroup]="verifyForm"/>
    <mx-filled-button label="Submit" [enabled]="verifyForm.valid" (click)="onClickNext()"/>
    <div>
      Didn't receive an email?
      <mx-text-button label="Resend code" (click)="onClickResend()" [enabled]="!recentlySent"/>
      @if (recentlySent) {
        <mat-error>Please wait a moment to resend the email.</mat-error>
      }
    </div>

  </mat-card-content>
</mat-card>

@if (viewportSelectors.isMdAndUp | select) {
  <div class="relative overflow-hidden flex flex-row items-center w-[50%] max-w-[18.7rem] lg:max-w-[26.35rem] lg:h-[30rem]">
    <img ngSrc="/assets/registration/verify-email.png" fill priority alt="" class="relative flex w-full h-auto"/>
  </div>
}
